module.exports = __webpack_public_path__ + "static/media/blue_arrow_24.a74afede.svg";